<template>
  <div class="input-plan w-100" :class="{ 'form-error': markAsFault }">
    <FormLabel :label="label" label-is-fake />
    <FormInputFeedback v-if="errorMsg">{{ errorMsg }}</FormInputFeedback>
    <template v-if="canShowWidget">
      <div class="row m-0">
        <div class="col text-right pr-0">
          <template v-if="leftToPlan > 0">
            Ancora da scadenziare: <strong><slot name="leftToPlan" :leftToPlan="leftToPlan">{{ leftToPlan | money }}</slot></strong>
          </template>
          <template v-else-if="leftToPlan < 0">
            Eccesso scadenziato: <strong><slot name="exceededToPlan" :exceededToPlan="exceededToPlan">{{ exceededToPlan | money }}</slot></strong>
          </template>
          <template v-else>
            Totale scadenziato
          </template>
        </div>
      </div>
      <div class="pay-per-month-table pb-3">
        <div class="row header m-0">
          <div class="col-4 col-lg-3"></div>
          <div class="col-4">Mese</div>
          <div class="col-4 col-lg-5">Importo</div>
        </div>
        <div class="row m-0 pt-2" v-for="(element, index) in payPerMonth" :key="element.month">
          <div class="col-4 col-lg-3">
            <div class="btn btn-outline-danger" :disabled='true' @click="removePlan(element.month)">Elimina</div>
          </div>
          <div class="col-4">
            <InputMonthPickerWidget
              class="w-100"
              :value="element.month"
              :not-required="true"
              :hideLabel="true"
              :errorMsg="errorHash[`month-${element.month}`]"
              @input="changeMonth(index, $event)"
            />
          </div>
          <div class="col-4 col-lg-5">
            <InputAmountWidget
              v-model.number="element.amount"
              :min="0"
              :not-required="true"
              :hideLabel="true"
              :errorMsg="errorHash[`importo-${element.month}`]"
              @input="changeAmount(index, $event)"
            />
          </div>
        </div>
        <div v-if="canShowAddMonth" class="row m-0 pt-2">
          <div class="col-auto">
            <button class="btn btn-outline-primary" @click.prevent="addMonth">Aggiungi mese</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <p>Seleziona il mese di inizio e l'importo da scadenziare</p>
    </template>
  </div>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate.js';
import formInputWidgetMixin from '@/libs/Form/components/Inputs/mixins/formInputWidget.js';
import formInputTextPropsMixin from '@/libs/Form/components/Inputs/mixins/formInputTextProps.js';

import formatMoney from '@/filters/formatMoney.js';
import { objectPlanToArrayPlan, arrayPlanToObjectPlan, thereAreEmptyMonths, getPlanTotal } from '@/helpers/plans.js';

export default {
  mixins: [validateMixin, formInputWidgetMixin, formInputTextPropsMixin],
  filters: {
    money: formatMoney,
  },
  components: {
    FormLabel: () => import('@/libs/Form/components/FormLabel.vue'),
    FormInputFeedback: () => import('@/libs/Form/components/FormFeedback.vue'),
    InputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget.vue'),
    InputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget.vue'),
  },
  props: {
    total: {
      type: Number,
      default: null,
    },
    value: {
      type: [Object, Array],
      default: () => ([]),
    },
    firstMonth: {
      required: true,
    },
  },
  computed: {
    isValueAnArray () {
      return Array.isArray(this.value);
    },

    payPerMonth () {
      return this.isValueAnArray ? (this.value || []) : objectPlanToArrayPlan(this.value);
    },
    nextMonth () {
      if (this.payPerMonth.length === 0) {
        return this.firstMonth;
      }

      const nextMonth = this.payPerMonth[this.payPerMonth.length - 1].month;
      if (!nextMonth) {
        return this.firstMonth;
      }

      const month = new Date(nextMonth);
      month.setMonth(month.getMonth() + 1);

      return `${month.getFullYear()}-${(month.getMonth() + 1).toString().padStart(2, '0')}`;
    },

    internalTotal () {
      return getPlanTotal(this.payPerMonth);
    },
    leftToPlan () {
      return (this.total || 0) - this.internalTotal;
    },
    exceededToPlan () {
      return this.leftToPlan < 0 ? this.leftToPlan * -1 : null;
    },

    canShowWidget () {
      return this.total !== null && this.firstMonth !== null;
    },
    thereIsEmptyMonth () {
      return thereAreEmptyMonths(this.payPerMonth);
    },
    canShowAddMonth () {
      return this.leftToPlan > 0 && !this.thereIsEmptyMonth;
    },
  },
  methods: {
    emitValue (months) {
      this.$emit('input', this.isValueAnArray ? months : arrayPlanToObjectPlan(months));
    },
    addMonth () {
      const value = [...this.payPerMonth];
      value.push({
        month: this.nextMonth,
        amount: this.leftToPlan,
      });

      this.emitValue(value);
    },
    changeMonth (index, newMonth) {
      if (!newMonth) {
        return;
      }

      const payPerMonth = [...this.payPerMonth];
      payPerMonth[index].month = newMonth;

      this.emitValue(payPerMonth);
    },
    changeAmount (index, newAmount) {
      const payPerMonth = [...this.payPerMonth];
      payPerMonth[index].amount = newAmount;

      this.emitValue(payPerMonth);
    },
    removePlan (month) {
      const payPerMonth = this.payPerMonth.filter(elem => elem.month !== month);

      this.emitValue(payPerMonth);
    },
  },
};

</script>

<style lang="scss">

.input-plan {
  .pay-per-month-table {
    border: 1px solid #279AD8;
  }

  .header {
    background: #279AD8;
    color: white;
    text-transform: uppercase;
  }
}

</style>
